import { render, staticRenderFns } from "./add_autocollection.vue?vue&type=template&id=53a029ba&"
import script from "./add_autocollection.vue?vue&type=script&lang=js&"
export * from "./add_autocollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports